import React, { useEffect, useMemo, useState } from "react";
import { BILLING_OPTIONS, OPTIONS, STATUS_OPTIONS } from "./config";
import InvestigationFilterDropdown from "components/Common/Dropdowns/InvestigationFilterDropdown";
import ZoneDropDown from "components/Common/Dropdowns/ZoneFilterDropDown";

const FilterPanelMaster = (props) => {
  const {
    filters,
    updateFilter,
    mrp,
    rate,
    mrpPercentage,
    ratePercentage,
    setMrp,
    setRate,
    setRatePercentage,
    setMrpPercentage,
    isSuperFranchise,
    isFranchise,
    isSubFranchise,
    transferRateToAllFranchise,
    setTransferRateToAllFranchise,
    editableRows,
    hasAppliedPercentageMap,
  } = props;

  const onRateChange = (event) => {
    const { value } = event.target;
    setRate(value);
  };

  const onMrpChange = (event) => {
    const { value } = event.target;
    setMrp(value);
  };

  const [investigationName, setInvestigationName] = useState(
    filters?.test_name || ""
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      if (investigationName.length >= 3) {
        updateFilter("test_name", investigationName);
      } else {
        updateFilter("test_name", "");
      }
    }, 500);

    return () => clearTimeout(handler);
  }, [investigationName]);

  const onInvestigationNameChange = (event) => {
    const { value } = event.target;
    setInvestigationName(value);
  };

  const onRatePercentageChange = (event) => {
    const { value } = event.target;
    setRatePercentage(value);
    // updateFilter("rate_percentage", value);
  };

  const onMrpPercentageChange = (event) => {
    const { value } = event.target;
    setMrpPercentage(value);
    updateFilter("mrp_percentage", value);
  };

  const filterVal = useMemo(() => {
    return (
      OPTIONS.find((option) => option.key === filters.keyword)?.value || ""
    );
  }, [filters]);

  const statusVal = useMemo(() => {
    return (
      STATUS_OPTIONS.find((option) => option.key === filters.is_active)
        ?.value || ""
    );
  }, [filters]);

  const billingCategoryVal = useMemo(() => {
    return (
      BILLING_OPTIONS.find((option) => option.key === filters.billing_category)
        ?.value || ""
    );
  }, [filters]);

  const setFilterValue = (keyname, value) => {
    updateFilter(keyname, value);
  };

  const onTransferRateChange = (e) => {
    setTransferRateToAllFranchise(e.target.checked);
  };

  return (
    <>
      <div className="dropdown w-100 d-flex flex-row">
        <div className="dropdown ms-3">
          <button
            className="dropdown-toggle btn mt-1 btn-o box-shadow-none active"
            role="button"
            data-bs-toggle="dropdown"
            style={{ border: "solid 1px #DEE2E6", height: "38px" }}
          >
            {statusVal}
          </button>
          <ul className="dropdown-menu">
            {STATUS_OPTIONS.map(({ key, value }) => (
              <li
                className="dropdown-item"
                onClick={() => updateFilter("is_active", key)}
                key={key}
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
        <div className="dropdown ms-3">
          <button
            className="dropdown-toggle btn mt-1 btn-o box-shadow-none active"
            role="button"
            data-bs-toggle="dropdown"
            style={{ border: "solid 1px #DEE2E6", height: "38px" }}
          >
            {billingCategoryVal}
          </button>
          <ul className="dropdown-menu">
            {BILLING_OPTIONS.map(({ key, value }) => (
              <li
                className="dropdown-item"
                onClick={() => updateFilter("billing_category", key)}
                key={key}
              >
                {value}
              </li>
            ))}
          </ul>
        </div>
        {/* <div className="ms-3" style={{ width: "250px" }}>
          <input
            type="text"
            className="form-control"
            placeholder="Enter Investigation Name"
            value={investigationName}
            onChange={onInvestigationNameChange}
          />
        </div> */}
        <div className="ms-3" style={{ width: "250px" }}>
          <InvestigationFilterDropdown
            setFilterValue={setFilterValue}
            className="w-100"
          />
        </div>
        {/* <div className="ms-3" style={{ width: "250px" }}>
          <DepartmentFilterDropDown
            setFilterValue={setFilterValue}
            className="w-100"
          />
        </div> */}
        {/* <div className="ms-3" style={{ width: "250px" }}>
          <PanelDropDown
            setFilterValue={setFilterValue}
            showSuperFranchise={true}
            className="w-100"
          />
        </div> */}
        {!isFranchise && !isSubFranchise ? (
          <div className="input-group ms-3" style={{ width: "250px" }}>
            <ZoneDropDown setFilterValue={setFilterValue} className="w-100" />
          </div>
        ) : null}
      </div>
      <div className="d-flex flex-wrap gap-2 mt-3 align-items-center">
        <span>Set selected rates:</span>
        <input className="form-control" style={{ width: "170px" }} type="number" min="0"
          value={rate} aria-label="Rate for selected franchises" placeholder="Rate"
          onChange={onRateChange} />
        {!isSuperFranchise && !isFranchise && !isSubFranchise && (
          <input className="form-control" style={{ width: "170px" }} type="number" min="0"
            value={mrp} aria-label="MRP for selected franchises" placeholder="MRP"
            onChange={onMrpChange} />
        )}
        <small className="text-muted">Manual row edits take priority. Save applies all selected rows together.</small>
      </div>
      {/* <div className="d-flex w-100 flex-row mt-2 justify-content-start">
        <div className="input-group ms-3" style={{ width: "200px" }}>
          <input
            type="number"
            value={ratePercentage || ""}
            placeholder="Enter Rate Percentage"
            className="form-control"
            aria-label="Rate Percentage"
            onChange={onRatePercentageChange}
          />
        </div>
        {isSuperFranchise != 1 && isFranchise != 1 && isSubFranchise != 1 ? (
          <>
            <div className="input-group ms-3" style={{ width: "200px" }}>
              <input
                type="number"
                value={mrpPercentage || ""}
                placeholder="Enter MRP Percentage"
                className="form-control"
                aria-label="MRP Percentage"
                onChange={onMrpPercentageChange}
              />
            </div>
            <div className="input-group ms-3" style={{ width: "200px" }}>
              <input
                type="number"
                value={rate || ""}
                placeholder="Enter Rate"
                className="form-control"
                aria-label="Rate"
                onChange={onRateChange}
              />
            </div>
            <div className="input-group ms-3" style={{ width: "200px" }}>
              <input
                type="number"
                value={mrp || ""}
                placeholder="Enter MRP"
                className="form-control"
                aria-label="MRP"
                onChange={onMrpChange}
              />
            </div>
            <div className="form-check ms-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="transferRateCheckbox"
                checked={transferRateToAllFranchise || false}
                onChange={onTransferRateChange}
              />
              <label
                className="form-check-label"
                htmlFor="transferRateCheckbox"
              >
                Transfer MRP Rate to All Franchise
              </label>
            </div>
          </>
        ) : null}
      </div> */}
    </>
  );
};

export default FilterPanelMaster;
